import { STRICT_TIME_PATTERN } from '../../../../constants';

// Server times may omit seconds or carry non-zero seconds; the pickers are minute-granular, so force seconds to :00. Non-time values pass through for parseStrictTimeValue to reject.
export const normalizeTimeSeconds = (value: string): string => {
  if (!STRICT_TIME_PATTERN.test(value)) return value;
  return `${value.slice(0, 5)}:00`;
};
